export default "__VITE_ASSET__B_$ZD2U9__"